import { render, staticRenderFns } from "./common-files.vue?vue&type=template&id=71026e40&"
import script from "./common-files.vue?vue&type=script&lang=js&"
export * from "./common-files.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports